import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import editIcon from "../../assets/edit.png";
import moreIcon from "../../assets/more.png";
import apiService from "../../services/api";
import { usePopup } from "../common/Popup";

const formatTipoAtividade = (tipo) => {
  const tipos = {
    ESTAGIO_OBRIGATORIO: "Estágio Obrigatório",
    ESTAGIO_SUPERVISIONADO: "Estágio Supervisionado",
    INTERNATO_MEDICO: "Internato Médico",
    AULA_PRATICA: "Aula Prática",
  };
  return tipos[tipo] || tipo;
};

const HeaderBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 50px;
  padding: 0 20px;
  background: #f2f0f0;
  border-bottom: 1px solid #ddd;
`;

const SpecialtyName = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #6ab8a8;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding-left: 20px;
`;

const VagasBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #f2f0f0;
  border-left: 1px solid #ddd;
  padding: 0 16px;
  height: 100%;
  font-size: 13px;
  font-weight: 700;
  color: #6ab8a8;
  min-width: 70px;
`;

const VagasCount = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #ff9f1f;
  line-height: 1;
`;

const CardOuter = styled.div`
  background: #fff;
  border-top: 1px solid #e0e0e0;
  border-right: 1px solid #f3f3f3;
  border-bottom: 1px solid #f3f3f3;
  border-left: none;
  overflow: hidden;
  max-width: 700px;
`;

const CardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: #e8f5f3;
  border-bottom: 1px solid #d0d0d0;
  padding-left: 40px;
`;

const UnitInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UnitLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 200px;
`;

const UnitName = styled.div`
  font-size: 16px;
  color: #555555;
  font-weight: 600;
`;

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 20%;
  background: #6ab8a8;
  color: white;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const UnitLabel = styled.div`
  font-size: 16px;
  color: #6ab8a8;
  font-weight: 600;
`;

const EditActionBtn = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  color: #ff9f1f;
  font-size: 13px;
  padding: 4px 6px;

  img {
    width: 20px;
    height: 20px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

const FieldRow = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 40px;
  border-bottom: 1px solid #efefef;
  min-height: 42px;

  &:last-child {
    border-bottom: none;
  }
`;

const HighlightFieldRow = styled(FieldRow)`
  background-color: #e8f5f3;
`;

const FieldLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: #555555;
  width: 210px;
  flex-shrink: 0;
`;

const FieldValue = styled.div`
  font-size: 16px;
  color: #555;
  flex: 1;
`;

const FieldInput = styled.input`
  flex: 1;
  padding: 6px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  color: #002e3b;
`;

const FieldSelect = styled.select`
  flex: 1;
  padding: 6px 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 6px;
  outline: none;
  background-color: white;
  color: #002e3b;
`;

const BottomArea = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  max-width: 700px;
  width: 100%;
  margin: 24px 0 0;
  padding: 0 20px;
`;

const VoltarButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #6ab8a8;
  color: white;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;

const SaveButton = styled.button`
  background-color: #6ab8a8;
  color: white;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const CancelButton = styled.button`
  background-color: #999;
  color: white;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  &:hover {
    background-color: #777;
  }
`;

const SolicitarButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background-color: #ff9f1f;
  color: white;
  font-size: 15px;
  font-weight: 600;
  padding: 8px 24px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 4px 3px rgba(0, 0, 0, 0.2);
  cursor: pointer;

  img {
    width: 18px;
    height: 18px;
  }

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const SolicitacoesSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 40px;
  border-top: 1px solid #dfe3e8;
  background: #f2f0f0;
  max-width: 700px;
`;

const SolicitacoesLabel = styled.div`
  font-size: 15px;
  color: #555;
  font-weight: 600;
`;

const SolicitacoesCount = styled.div`
  font-size: 18px;
  font-weight: 800;
  color: #ff9f1f;
  min-width: 24px;
  text-align: center;
`;

const VerSolicitacoesButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #6ab8a8;
  color: white;
  font-size: 14px;
  font-weight: 600;
  padding: 6px 18px;
  border: none;
  border-radius: 8px;
  box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  margin-left: auto;

  &:hover {
    opacity: 0.9;
  }
`;

const getInitials = (nome = "") => {
  const parts = nome.trim().split(/\s+/);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return nome.slice(0, 2).toUpperCase();
};

const VagaDetalhe = ({
  vaga: initialVaga,
  user,
  onVoltar,
  onSolicitar,
  onVerSolicitacoes,
}) => {
  const popup = usePopup();
  const [isEditing, setIsEditing] = useState(false);
  const [vaga, setVaga] = useState(initialVaga);
  const [formData, setFormData] = useState({
    tipoAtividade: initialVaga.tipoAtividade || "",
    quantidade: initialVaga.quantidade || "",
    turno: initialVaga.turno || "",
  });
  const [saving, setSaving] = useState(false);
  const [solicitacoesCount, setSolicitacoesCount] = useState(0);

  const navigate = useNavigate();
  const canEdit = user?.cargoId === 1 || user?.cargoId === 4;
  const isSolicitante = user?.cargoId === 2 || user?.cargoId === 3;

  useEffect(() => {
    if (!isSolicitante || !vaga?.id) return;
    const fetchCount = async () => {
      try {
        const result = await apiService.getSolicitacoesVaga(null, vaga.id);
        const data = result?.data ? result.data : result;
        setSolicitacoesCount(Array.isArray(data) ? data.length : 0);
      } catch {
        setSolicitacoesCount(0);
      }
    };
    fetchCount();
  }, [isSolicitante, vaga?.id]);
  const solicitarDisabled =
    vaga?.quantidadeDisponivel === null ||
    vaga?.quantidadeDisponivel === undefined ||
    Number(vaga.quantidadeDisponivel) <= 0;

  const handleChange = (field) => (e) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      const payload = {
        tipoAtividade: formData.tipoAtividade,
        quantidade: Number(formData.quantidade),
        turno: formData.turno,
      };
      const vagaAtualizada = await apiService.updateVaga(vaga.id, payload);
      setVaga((prev) => ({ ...prev, ...vagaAtualizada }));
      setIsEditing(false);
      await popup.alert({
        icon: "success",
        message: "Vaga atualizada com sucesso!",
      });
    } catch (err) {
      await popup.alert({
        icon: "warning",
        title: "Erro ao atualizar vaga",
        message: err.message || "Tente novamente.",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      tipoAtividade: vaga.tipoAtividade || "",
      quantidade: vaga.quantidade || "",
      turno: vaga.turno || "",
    });
    setIsEditing(false);
  };

  const uniteName = vaga.estabelecimentoSaude?.nome || "";

  return (
    <>
      <HeaderBar>
        <SpecialtyName>
          {vaga.unidadeAssistencial?.especialidade?.nome || "Vaga"}
        </SpecialtyName>
        <VagasBadge>
          <div>VAGAS</div>
          <VagasCount>{vaga.quantidade ?? "-"}</VagasCount>
        </VagasBadge>
      </HeaderBar>

      <CardOuter>
        <CardTopRow>
          <UnitInfo>
            <UnitLeft>
              <Avatar>{getInitials(uniteName)}</Avatar>
              <UnitLabel>Unidade de Saúde:</UnitLabel>
            </UnitLeft>
            <UnitName>{uniteName || "-"}</UnitName>
          </UnitInfo>
          {canEdit && (
            <EditActionBtn
              onClick={() => (isEditing ? handleCancel() : setIsEditing(true))}
              title={isEditing ? "Cancelar edição" : "Editar vaga"}
            >
              <img src={editIcon} alt="Editar" />
              {isEditing ? "cancelar" : "Editar"}
            </EditActionBtn>
          )}
        </CardTopRow>

        <HighlightFieldRow>
          <FieldLabel>Curso:</FieldLabel>
          <FieldValue>{vaga.areaCurso?.nome || "-"}</FieldValue>
        </HighlightFieldRow>

        <HighlightFieldRow>
          <FieldLabel>Setor:</FieldLabel>
          <FieldValue>{vaga.unidadeAssistencial?.nome || "-"}</FieldValue>
        </HighlightFieldRow>

        <FieldRow>
          <FieldLabel>Quantidade de Vagas:</FieldLabel>
          {isEditing ? (
            <FieldInput
              type="number"
              min="1"
              value={formData.quantidade}
              onChange={handleChange("quantidade")}
            />
          ) : (
            <FieldValue>{vaga.quantidade ?? "-"}</FieldValue>
          )}
        </FieldRow>

        <FieldRow>
          <FieldLabel>Tipo de Atividade:</FieldLabel>
          {isEditing ? (
            <FieldSelect
              value={formData.tipoAtividade}
              onChange={handleChange("tipoAtividade")}
            >
              <option value="">Selecione</option>
              <option value="ESTAGIO_OBRIGATORIO">Estágio Obrigatório</option>
              <option value="ESTAGIO_SUPERVISIONADO">
                Estágio Supervisionado
              </option>
              <option value="INTERNATO_MEDICO">Internato Médico</option>
              <option value="AULA_PRATICA">Aula Prática</option>
            </FieldSelect>
          ) : (
            <FieldValue>{formatTipoAtividade(vaga.tipoAtividade)}</FieldValue>
          )}
        </FieldRow>

        <FieldRow>
          <FieldLabel>Turno:</FieldLabel>
          {isEditing ? (
            <FieldSelect
              value={formData.turno}
              onChange={handleChange("turno")}
            >
              <option value="">Selecione</option>
              <option value="Matutino">Matutino</option>
              <option value="Vespertino">Vespertino</option>
              <option value="Noturno">Noturno</option>
            </FieldSelect>
          ) : (
            <FieldValue>{vaga.turno || "-"}</FieldValue>
          )}
        </FieldRow>
      </CardOuter>

      {isSolicitante && (
        <SolicitacoesSection>
          <SolicitacoesLabel>Número de solicitações:</SolicitacoesLabel>
          <SolicitacoesCount>{solicitacoesCount}</SolicitacoesCount>
          {solicitacoesCount > 0 && (
            <VerSolicitacoesButton
              onClick={() => {
                if (onVerSolicitacoes) {
                  onVerSolicitacoes(vaga);
                } else {
                  navigate("/VagasSolicitadas", { state: { vagaId: vaga.id } });
                }
              }}
              title="Ver solicitações desta vaga"
            >
              Ver solicitações
            </VerSolicitacoesButton>
          )}
        </SolicitacoesSection>
      )}

      <BottomArea>
        {isEditing ? (
          <>
            <CancelButton onClick={handleCancel}>Cancelar</CancelButton>
            <SaveButton onClick={handleSave} disabled={saving}>
              {saving ? "Salvando..." : "Salvar"}
            </SaveButton>
          </>
        ) : (
          <>
            {isSolicitante && (
              <SolicitarButton
                onClick={() => {
                  if (solicitarDisabled) return;
                  onSolicitar && onSolicitar(vaga);
                }}
                disabled={solicitarDisabled}
                title={solicitarDisabled ? "Sem vagas disponíveis" : "Solicitar vaga"}
              >
                <img src={moreIcon} alt="Solicitar" />
                Solicitar Vaga
              </SolicitarButton>
            )}
            <VoltarButton onClick={onVoltar}>
              Voltar
            </VoltarButton>
          </>
        )}
      </BottomArea>
    </>
  );
};

export default VagaDetalhe;
